import { render, staticRenderFns } from "./LocalCartItem.vue?vue&type=template&id=6afdc112&scoped=true"
import script from "./LocalCartItem.vue?vue&type=script&lang=js"
export * from "./LocalCartItem.vue?vue&type=script&lang=js"
import style0 from "./LocalCartItem.vue?vue&type=style&index=0&id=6afdc112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdc112",
  null
  
)

export default component.exports